// extracted by mini-css-extract-plugin
export default {"container":"SocialLinks_container__fPF9-","link":"SocialLinks_link__vfXWX","icon":"SocialLinks_icon__Tvoh1"};